/**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */

const originalHeight  = 1400;

$window
    .on('resize', function () {
        el.style.fontSize = `${el.offsetWidth * 100 / wW / originalHeight}vw`;
    });
